import React, { useMemo } from 'react';
import { useLocation } from 'react-router';
import { Link, useSearchParams } from 'react-router-dom';

import PaginacaoInterface from 'Interface/Paginacao';

interface Props {
    dados?: PaginacaoInterface;
    desabilitado?: boolean;
}

const Paginacao = ({ dados, desabilitado = false }: Props): React.ReactElement =>
{
    const [ searchParams ] = useSearchParams();
    const { search, pathname } = useLocation()

    const posicao = searchParams.get('pagina') || '1';

    const paginas = useMemo(() => {
        const paginas: Array<number> = [];

        if (!dados) return paginas;

        for (let i = dados.page - 2; i <= dados.page + 2; i++) {
            if (i >= 1 && i <= dados.pageCount) {
                paginas.push(i);
            }
        }

        return paginas;
    }, [ dados ]);

    const queryString = (query: string, posicao: number): string =>
    {
        const querystring = new URLSearchParams(query);

        querystring.delete('pagina');

        if (posicao && posicao != 1) {
            querystring.append('pagina', posicao.toString());
        }

        return querystring.toString();
    }

    return (
        <React.Fragment>
            { dados && dados.count > 0 && (
                <nav className="mt-4">
                    <ul className="pagination">
                        { dados.prevPage && (
                            <li className={ `page-item ${desabilitado && 'disabled'}` }>
                                <Link className="page-link bg-dark border-dark" to={{
                                    pathname: pathname,
                                    search: queryString(search, parseInt(posicao) - 1),
                                }}>
                                    Anterior
                                </Link>
                            </li>
                        ) }
                        { paginas.map(pagina => (
                            <li
                                key={ pagina.toString() }
                                className={ `page-item ${desabilitado && 'disabled'} ${pagina == dados.page && 'active'}` }
                            >
                                <Link className={ `page-link ${pagina != dados.page && 'bg-dark border-dark'}` } to={{
                                    pathname: pathname,
                                    search: queryString(search, pagina),
                                }}>
                                    { pagina }
                                </Link>
                            </li>
                        )) }
                        { dados.nextPage && (
                            <li className={ `page-item ${desabilitado && 'disabled'}` }>
                                <Link className="page-link bg-dark border-dark" to={{
                                    pathname: pathname,
                                    search: queryString(search, parseInt(posicao) + 1),
                                }}>
                                    Próximo
                                </Link>
                            </li>
                        ) }
                    </ul>
                </nav>
            ) }
        </React.Fragment>
    )
}

export default Paginacao;
